import { render, staticRenderFns } from "./ffuploadimgs.vue?vue&type=template&id=38beec24&"
import script from "./ffuploadimgs.vue?vue&type=script&lang=js&"
export * from "./ffuploadimgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports